<template>
  <div class="reportDetailPage" id="report2">
    <div class="repTop">
      <div class="topCon">
        <div class="imgCon">
          <img src="img/repMap.webp" alt="">
        </div>
        <div class="detailCon">
          <div class="titleBlack">
            {{ option.userName }}电气火灾超前预警报告
          </div>
          <div class="detBom">
            <div class="detItem">
              <span>报告编号：</span>
              <span>{{ option.number }}</span>
            </div>
            <br>
            <div class="detItem">
              <span>报告周期：</span>
              <span>{{ option.datePeriod }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="repBtn" :class="{ generating: reportStatus === 'generating' }" @click="handleReportAction">
        <span v-if="reportStatus === 'generating'" class="rep-btn-spinner"></span>
        {{ reportButtonText }}
      </div>
    </div>

    <part-box :num="1" :title="'隐患分类'">
      <div class="fuTitle">
        监测点隐患维度分类
      </div>
      <div class="grayTitle">
        共有<span class="risk-type-count">{{ ReportSummary.total }}</span>个监测点,有隐患监测点<span
        class="risk-type-count">{{ ReportSummary.hasRiskCount }}</span>个,占比<span
        class="risk-type-count">{{ ReportSummary.total === 0 ? 0 : ((ReportSummary.hasRiskCount / ReportSummary.total) * 100).toFixed(2) }}</span>
        %,其中有严重和较大风险的监测点<span class="risk-type-count">{{ ReportSummary.level45Count }}</span>
        个,占比<span class="risk-type-count">{{ ReportSummary.total === 0 ? 0 : ((ReportSummary.level45Count / ReportSummary.hasRiskCount) * 100).toFixed(2) }}</span>%。
      </div>
      <div class="grayFont">{{ reportRule }}</div>
      <div class="cavGroup">
        <div class="count-box">
          <div class="cavItem">
            <div class="blackFont">{{ ReportSummary.total }}</div>
            <div class="grayFont">监测点总数</div>
          </div>
          <div class="cavItem">
            <div class="orgFont">{{ ReportSummary.hasRiskCount }}</div>
            <div class="grayFont">隐患监测点</div>
          </div>
          <div class="cavItem">
            <div class="redFont">{{ ReportSummary.level45Count }}</div>
            <div class="grayFont">严重和较大风险</div>
          </div>
        </div>
        <div class="count-box">
          <div>
            <div id="fircav" class="leftCav"></div>
          </div>
          <div>
            <div id="seccav" class="leftCav"></div>
          </div>
        </div>
      </div>
      <div class="risk-level-box">
        <div class="listItem" v-for="level in levelIterateSort" :key="level">
          <div class="line-chart-item" >
            <span class="level-name">{{levelNames[level]}}</span>
              <span class="base-line">
                <!-- 主风险等级条形 -->
                <span v-if="calcMainBarWidth(level) > 0"
                  class="active-line"
                  :style="{
                    'width': calcMainBarWidth(level) + '%',
                    'background-image': 'linear-gradient(to right,' + (levelColor2[level] || 'rgba(142, 202, 254, 1)') + ',' + (levelColor[level] || 'rgba(56, 99, 221, 1)'),
                    'border-radius': (levelToFalseAlarmCountMap[level] > 0) ? '1vw 0 0 1vw' : '1vw'
                  }">
                </span>
                <!-- 误报源叠加条形 -->
                <span v-if="levelToFalseAlarmCountMap[level] > 0"
                  class="false-alarm-line"
                  :style="{
                    'width': calcFalseAlarmBarWidth(level) + '%',
                    'background-image': 'linear-gradient(to right,' + (levelColor2[6] || 'rgba(212, 212, 212, 1)') + ',' + (levelColor[6] || 'rgba(150, 150, 150, 1)'),
                    'border-radius': calcMainBarWidth(level) > 0 ? '0 1vw 1vw 0' : '1vw',
                    'min-width': '4px'
                  }">
                </span>
              </span>
            <span class="risk-type-count">
                {{ levelToCountMap[level] }} ({{ ReportSummary.total === 0 ? 0 : ((levelToCountMap[level] / ReportSummary.hasRiskCount).toFixed(2) * 100).toFixed(0) }}%)
              </span>
          </div>
          <p>存在{{levelNames[level]}}风险的监测点有<span class="risk-type-count">{{levelToCountMap[level]}}</span>个（占比{{ReportSummary.total === 0 ? 0 : ((levelToCountMap[level] / ReportSummary.hasRiskCount).toFixed(2) * 100).toFixed(0) }}%）
            <span v-if="levelToFalseAlarmCountMap[level] > 0">，其中<span class="misreport-count">{{levelToFalseAlarmCountMap[level]}}</span>个同时存在<span class="misreport-label">{{levelNames[6]}}</span></span>
            {{levelToRiskCountMap[level] && levelToRiskCountMap[level].length > 0 ? '，其中存在' : '' }}
            <span v-for="(item , index) in levelToRiskCountMap[level]" :key="index">
              <span>{{ item.name }} 的监测点</span><span class="risk-type-count">{{ item.value }}个{{ index === levelToRiskCountMap[level].length - 1 ? '。' : '，' }}</span>
            </span>
          </p>
        </div>
      </div>
    </part-box>

    <part-box :num="2" :title="'重点关注监测点'">
      <div class="fuTitle">
        中高危隐患点位分析
      </div>
      <div class="grayTitle">
        本周监测点位<span class="risk-type-count">{{ ReportSummary.total }}</span>个，共
        <span class="risk-type-count">{{ ReportSummary.level45Count }}</span>个监测点需要关注
      </div>
      <div class="hidden-card">
        <Card v-for="(item, index) in cardList"
              :index="index"
              :key="item.id"
              :data="item"
              :start-time="periodStartTime"
              :end-time="periodEndTime"
        />
      </div>
    </part-box>

    <part-box :num="3" :title="'筛查隐患结果'">
      <div class="fuTitle">
        隐患监测点筛查列表
        <span class="grayFont" style="margin-left: 16px;">筛查存在隐患监测点共<span class="risk-type-count"> {{ monitortotal }}</span>个，请重点关注严重隐患和较大隐患</span>
      </div>
      <div class="bigtableList">
        <div class="tableItem" v-loading="loading" element-loading-text="加载中...">
          <el-table :data="monitorSiteList" :span-method="riskSpanMethod" style="width: 100%" border class="el-table--border" :border-color="'#EBEEF5'" cell-class-name="table-cell">
            <el-table-column prop="name" label="监测点"></el-table-column>
            <el-table-column prop="maxRisk" label="安全状态"></el-table-column>
            <el-table-column prop="riskLevel" label="风险等级"></el-table-column>
            <el-table-column prop="riskName" label="隐患"></el-table-column>
            <el-table-column prop="phase" label="隐患定位"></el-table-column>
            <el-table-column
              prop="summary"
              label="隐患设备">
              <template slot-scope="scope">
                <div style="text-align: left;">
                  <div v-for="(item, index) in scope.row.summary.split(';\n')" :key="index" style="text-align: left;">
                    {{ item }}
                  </div>
                </div>
                <el-button v-if="scope.row.summary" type="text" size="small" @click="handleView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page">
          <el-pagination
            @current-change="pageChange"
            background
            :current-page="page"
            :page-size="sizePage"
            layout="total,prev, pager, next, jumper"
            :total="totalSum">
          </el-pagination>
        </div>
      </div>
    </part-box>

    <part-box :num="4" :title="'数据参照标准'">
      <TableRules />
    </part-box>

    <el-dialog
      title="详细信息"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose">
      <div v-if="currentDevice">
        <div class="dialog-content">
          <h3>监测点名称：{{ currentDevice.name }}</h3>
          <div v-for="(device, rIndex) in currentDevice.riskDevices" :key="rIndex" class="device-info">
            <p class="message-text">{{ device.message }}</p>
            <div v-if="device.analogData && device.analogData.paramsList">
              <div v-for="(param, pIndex) in device.analogData.paramsList" :key="pIndex">
                <div :id="'dialogChart_' + rIndex + '_' + pIndex" class="chart-container"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import html2canvas from 'html2canvas';
import Axios2 from "@/utils/Axios2";
import qs from "qs";
import TableRules from "pages/report/components/tableRules.vue";
import PartBox from "pages/report/components/part-box.vue";
import Card from "pages/report/components/card.vue";
import report from "@/scripts/report"
import riskLevel from "@/scripts/riskLevel";

export default {
  name: "reportDetailPage",
  components: {Card, PartBox, TableRules },
  data() {
    return {
      option: {
        number: "",
        name: "",
        userName: "",
        type: "",
        datePeriod: "",
      },
      periodStartTime:'',
      periodEndTime:'',
      reportRule:'（注：按照国际标准《对剩余电流动作保护器的一般要求》IEC 60755:2017，国内标准《电气火灾监控报警系统》GB14287-2（2014）、《超前预警电气火灾监控系统技术标准》T/CASA-2022、《剩余电流控制保护电器的一般安全要求》GB/T 6829-2024等相关规定：用于人身保护<30mA，用于火灾防护<300mA。)',
      ReportSummary: {
        eventCount: "",
        greaterRiskMonitorCount: "",
        greaterRiskUnhandledCount: "",
        handledRiskCount: "",
        monitorCount: "",
        riskCount: "",
        riskMonitorCount: "",
        significantRiskMonitorCount: "",
        significantRiskUnhandledCount: "",
      },
      RiskCount: {
        falseAlarmCount: "",
        generalRiskCount: "",
        greaterRiskCount: "",
        lowerRiskCount: "",
        riskTotal: "",
        significantRiskCount: "",
      },
      levelToCountMap: {},
      levelToFalseAlarmCountMap: {},
      levelToRiskCountMap: {},
      levelNames: ["未知", "正常", "早期", "一般", "较大", "严重", riskLevel.name(6)],
      levelColor: ["#8CC8FD", "#4facff", "rgba(0, 107, 195)", "rgba(255, 176, 0)", "rgba(217, 97, 0)", "rgba(255, 0, 0)", "#acacac"],
      levelColor2: ["#8CC8FD", "#8CC8FD", "rgba(0, 107, 195,0.5)", "rgba(255, 176, 0, 0.5)", "rgba(217, 97, 0, 0.5)", "rgba(255, 0, 0, 0.8)", "#d5d5d5"],
      color: "#fad029",
      levelIterateSort: [5, 4, 3, 2],
      toriskLevelcount: [],
      monitorSiteList: [], // 存储监测点列表数据
      cardList:[],
      monitortotal:"",
      riskdevicetotal:"",
      pagesize:10,
      riskDevices: [], // 用于存储风险设备数据
      page: 1,
      sizePage: 10,
      totalSum: 0,
      dialogVisible: false,
      currentDevice: null,
      dialogChartData: null,
      reportStatus: 'generate', // 'generate' | 'generating' | 'export'
      reportFileUrl: '',
      reportGenerateInterval: null,
      isFirstLoad: true,
      loading: false,
    };
  },
  computed: {
    reportButtonText() {
      switch (this.reportStatus) {
        case 'generating':
          return '生成中';
        case 'export':
          return '导出报告';
        case 'generate':
        default:
          return '生成报告';
      }
    },
    calcFalseAlarmStandaloneWidth() {
      if (this.ReportSummary.total === 0) return 0;
      const falseAlarmOnlyCount = this.levelToCountMap[6] || 0;
      if (falseAlarmOnlyCount === 0) return 0;
      const base = this.ReportSummary.hasRiskCount || 1;
      return ((falseAlarmOnlyCount / base).toFixed(2) * 100).toFixed(0);
    }
  },
  methods: {
    riskSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 如果是名称列或最大风险列
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 5) {
        // 获取当前行的名称
        const currentName = row.name;
        if (rowIndex !== 0 && this.monitorSiteList[rowIndex - 1].name === currentName) {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
        // 计算当前名称的连续行数
        let count = 0;
        for (let i = rowIndex; i < this.monitorSiteList.length; i++) {
          if (this.monitorSiteList[i].name === currentName) {
            count++;
          } else {
            break;
          }
        }
        if (count > 0) {
          return {rowspan: count, colspan: 1}
        } else {
          return {
            rowspan: 1,
            colspan: 1,
          }
        }
      }

      return {
        rowspan: 1,
        colspan: 1
      };
    },
    dataURLToBlob(dataurl) {//ie 图片转格式
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {type: mime})
    },
    downloadResult(name) {
      let canvasID = document.getElementById('report2')
      let a = document.createElement('a');
      html2canvas(canvasID).then(canvas => {
        let dom = document.body.appendChild(canvas);
        dom.style.display = "none";
        a.style.display = "none";
        document.body.removeChild(dom);
        let blob = this.dataURLToBlob(dom.toDataURL("image.webp"));
        a.setAttribute("href", URL.createObjectURL(blob));
        a.setAttribute("download", name + ".webp")
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(blob);
        document.body.removeChild(a);
      });
    },
    printOut(name) {
      document.documentElement.scrollTop = 0; // 其他
      this.downloadResult(name)
    },
    /** 仅带报告编号的入口（免登/独立标签页）回查报告头信息；取不到也按编号继续渲染正文 */
    loadReportInfo(reportNumber) {
      return report.getReportInfo(reportNumber).then((res) => {
        if (res && res.data) {
          this.option = Object.assign({}, this.option, res.data);
        }
      }).catch(() => {
        console.warn('报告基本信息获取失败，按报告编号继续渲染');
        this.$message.error('报告信息获取失败，报告名称与周期暂无法显示');
      });
    },
    queryReportSummaryData() {
      let param = {};
      param.method = "get";
      param.url = "/api/v1/risk/monitor_site/statistic";
      param.params = {
        reportNumber: this.option.number,
      };
      Axios2.ajax(param).then((res) => {
        this.ReportSummary = res.data
        this.hasRiskPieChart(res.data.total, res.data.hasRiskCount)
        this.riskSeverityPieChart(res.data.level45Count, res.data.hasRiskCount - res.data.level45Count)
        this.toriskLevelcount = res.data.riskLevels
        this.buildLevelToCountMap()
        this.buildLevelToFalseAlarmCountMap()
        // 处理 riskLevels 数据
        if (this.toriskLevelcount && this.toriskLevelcount.length) {
          let levelRiskCountMap = {}
          for (let i = 0; i < this.toriskLevelcount.length; i++) {
            const levelData = this.toriskLevelcount[i];
            if (!levelData.riskType || !levelData.riskType.length) continue;
            levelRiskCountMap[levelData.level] = []
            for (let j = 0; j < levelData.riskType.length; j++) {
              const type = levelData.riskType[j];
              const item = {
                name: type.name,
                value: type.count
              };
              levelRiskCountMap[levelData.level].push(item)
            }
          }
          this.levelToRiskCountMap = levelRiskCountMap
        }
      });
    },
    buildLevelToCountMap() {
      this.levelToCountMap = this.toriskLevelcount.reduce((map, item) => {
        map[item.level] = item.count;
        return map;
      }, {});
    },
    buildLevelToFalseAlarmCountMap() {
      this.levelToFalseAlarmCountMap = this.toriskLevelcount.reduce((map, item) => {
        map[item.level] = item.falseAlarmCount || 0;
        return map;
      }, {});
    },
    calcMainBarWidth(level) {
      if (this.ReportSummary.total === 0) return 0;
      const falseAlarmCount = this.levelToFalseAlarmCountMap[level] || 0;
      const mainCount = this.levelToCountMap[level] - falseAlarmCount;
      return ((mainCount / this.ReportSummary.hasRiskCount).toFixed(2) * 100).toFixed(0);
    },
    calcFalseAlarmBarWidth(level) {
      if (this.ReportSummary.total === 0) return 0;
      const falseAlarmCount = this.levelToFalseAlarmCountMap[level] || 0;
      return ((falseAlarmCount / this.ReportSummary.hasRiskCount).toFixed(2) * 100).toFixed(0);
    },
    getmonitor_site() {
      this.loading = true;
      let param = {};
      param.method = "get";
      param.url = "/api/v1/risk/monitor_site/data/list";
      param.params = {
        reportNumber: this.option.number,
        pageNum: this.page,
        pageSize: this.sizePage,
      };
      Axios2.ajax(param).then((res) => {
        if (res && res.data && res.data.records) {
          let tableRecords = [];
          let siteToSummaryMap = {};
          res.data.records.forEach(item => {
            if (item.riskDevices && item.riskDevices.length > 0) {
              siteToSummaryMap[item.id] = item.riskDevices.map(device => device.summary).join(';\n');
            } else {
              siteToSummaryMap[item.id] = '';
            }
          });

          res.data.records.forEach((item, index) => {
            item.riskGroups.forEach((item1, index) => {
              tableRecords.push({
                id: item.id,
                name: item.name,
                maxRisk: item.maxRisk,
                riskName: item1.name,
                riskLevel: item1.level,
                phase: item1.phase,
                summary: siteToSummaryMap[item.id]
              })
            })
          })
          this.monitorSiteList = tableRecords;
          this.monitortotal = res.data.total;
          this.totalSum = res.data.total;

          this.$nextTick(() => {
            if (this.isFirstLoad) {
              window.scrollTo(0, 0);
              this.isFirstLoad = false;
            } else {
              const titles = document.querySelectorAll('.firTitle');
              for (let title of titles) {
                if (title.textContent.includes('2')) {
                  title.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  break;
                }
              }
            }
          });
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    getHidden_card(){
      let param = {};
      param.method = "get";
      param.url = "/api/v1/risk/monitor_site/data/list";
      param.params = {
        reportNumber: this.option.number,
        minRiskLevel: 4,
        chartParam: 1,
        inspection: 1,
        manualAnalysisRecord: 1,
        pageNum: this.page,
        pageSize: this.sizePage,
      };
      Axios2.ajax(param).then((res) => {
        this.cardList = res.data.records;
      });
    },
    pageChange(val) {
      this.page = val;
      this.getmonitor_site();
      this.getHidden_card();
    },
    getcavdata(index, rIndex, pIndex, params, startTime, endTime, chartId) {
      let param = {};
      param.method = "post";
      param.url = "/analogData/instantParamDataV2";
      param.data = qs.stringify({
        monitorSiteId: this.currentDevice.id,
        params: params,
        searchDate: startTime.split(' ')[0],
        startTime: startTime,
        endTime: endTime,
      });

      Axios.ajax(param).then((res) => {
        if (res.resultCode === '0') {
          const title = res.data[0];
          const data = res.data.slice(1);
          this.drewcav(title, data, chartId);
        }
      });
    },
    drewcav(title, data, chartId, description) {
      let xdata = [];
      let series = [];
      let legend = [];

      let colorlist = [
        'rgba(87,128,250,1)',
        '#85f67a',
        '#FFA940',
        '#19AF23',
        '#AAAF23',
        '#00A9ee',
        '#0011ee'
      ];

      // 处理数据系列
      for (let i = 1; i < title.length; i++) {
        let color = '';
        if (title[i].indexOf('A相') !== -1) {
          color = 'rgb(255,165,0)';
        } else if (title[i].indexOf('B相') !== -1) {
          color = 'rgb(0,128,0)';
        } else if (title[i].indexOf('C相') !== -1) {
          color = 'rgb(255,0,0)';
        } else {
          color = colorlist[i - 1];
        }

        series.push({
          name: title[i],
          type: 'line',
          yAxisIndex: 0,
          smooth: true,
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: color
              }, {
                offset: 1,
                color: color
              }]),
              barBorderRadius: 11,
            }
          },
          data: []
        });
        legend.push(title[i]);
      }

      // 处理数据
      for (let i = 0; i < data.length; i++) {
        xdata.push(data[i][0]);
        for (let j = 1; j < data[i].length; j++) {
          series[j - 1].data.push(data[i][j]);
        }
      }

      // 初始化图表
      let myChart = this.$echarts.init(document.getElementById(chartId));

      let option = {

        tooltip: {
          trigger: 'axis',
          confine: true,
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: legend,
          top: 10
        },
        grid: {
          right: '2%',
          bottom: '10%',
          left: '5%',
          top: '40px',
          containLabel: false
        },
        xAxis: [{
          type: 'category',
          data: xdata,
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#000",
              fontSize: 12,
            }
          },
        }],
        yAxis: [{
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            color: '#000',
            fontSize: 12,
          }
        }],
        series: series
      };

      myChart.setOption(option);

      // 添加点击事件
      myChart.on('click', (param) => {
        // console.log(param);
        // console.log(description);
      });

      // 自适应大小
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    },
    hasRiskPieChart(sum, riskMonitorCount) {
      const domId = "fircav"
      const chart = this.$echarts.init(document.getElementById("fircav"));
      const option = {
        color: ["rgba(217, 97, 0, 1)", "rgba(230, 233, 236, 1)"],

        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "center",
          right: "10%",
          icon: "circle",
          itemGap: 20,
        },
        series: [
          {
            name: "监测点隐患占比情况",
            type: "pie",
            radius: ["30%", "70%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            data: [{value: riskMonitorCount, name: "有隐患监测点"},
              {value: sum - riskMonitorCount, name: "无隐患监测点"},],
          },
        ],
      };
      chart.setOption(option);
      window.onresize = chart.resize;
    },
    riskSeverityPieChart(data1, data2) {
      const domId = "seccav";
      const chart = this.$echarts.init(document.getElementById(domId));
      const option = {
        color: ["rgba(217, 0, 0, 1)", "rgba(230, 233, 236, 1)"],

        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "center",
          right: "10%",
          icon: "circle",
          itemGap: 20,
        },
        series: [
          {
            name: "监测点风险占比情况",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            data: [{value: data1, name: "严重和较大风险"},
              {value: data2, name: "其他风险"},],
          },
        ],
      };
      chart.setOption(option);
      window.onresize = chart.resize;
    },
    replaceChartsAsImg(chart, elementId) {
      chart.on('finished', function () {
        // 导出为 SVG
        const svgContent = chart.getDataURL({
          type: 'svg',
          pixelRatio: 2,
          backgroundColor: '#fff'
        });
        // 将 SVG 内容插入到原echarts的 DOM 元素中
        const svgContainer = document.getElementById(elementId);
        svgContainer.innerHTML = `<img src="${svgContent}" alt="ECharts 图表" style="width: 100%; height: auto;" />`;
      })
    },
    async handleView(row) {
      try {
        const currentDevice = this.monitorSiteList.find(item => item.id === row.id);
        if (!currentDevice) {
          this.$message.error('未找到监测点信息');
          return;
        }

        let param = {};
        param.method = "get";
        param.url = "/api/v1/risk/monitor_site/data/list";
        param.params = {
          reportNumber: this.option.number,
          pageNum: this.page,
          pageSize: this.sizePage,
        };

        const res = await Axios2.ajax(param);
        if (res && res.data && res.data.records) {
          const deviceData = res.data.records.find(item => item.id === row.id);
          if (!deviceData || !deviceData.riskDevices || deviceData.riskDevices.length === 0) {
            this.$message.error('未找到设备详细信息');
            return;
          }

          this.currentDevice = {
            id: deviceData.id,
            name: deviceData.name,
            riskDevices: deviceData.riskDevices
          };
          this.dialogVisible = true;
          this.$nextTick(() => {
            this.currentDevice.riskDevices.forEach((riskDevice, rIndex) => {
              if (riskDevice.analogData && riskDevice.analogData.paramsList) {
                riskDevice.analogData.paramsList.forEach((param, pIndex) => {
                  const chartId = `dialogChart_${rIndex}_${pIndex}`;
                  this.getcavdata(
                    0,
                    rIndex,
                    pIndex,
                    param,
                    riskDevice.analogData.startTime,
                    riskDevice.analogData.endTime,
                    chartId
                  );
                });
              }
            });
          });
        }
      } catch (error) {
        console.error('获取设备详细信息错误:', error);
        this.$message.error('获取设备详细信息失败');
      }
    },

    handleClose() {
      // 清除所有图表
      if (this.currentDevice && this.currentDevice.riskDevices) {
        this.currentDevice.riskDevices.forEach((device, rIndex) => {
          if (device.analogData && device.analogData.paramsList) {
            device.analogData.paramsList.forEach((param, pIndex) => {
              const chartId = `dialogChart_${rIndex}_${pIndex}`;
              const chartDom = document.getElementById(chartId);
              if (chartDom) {
                this.$echarts.dispose(chartDom);
              }
            });
          }
        });
      }
      this.dialogVisible = false;
      this.currentDevice = null;
    },
    handleReportAction() {
      switch (this.reportStatus) {
        case 'generate':
          this.generateReport();
          break;
        case 'generating':
          // 正在生成中，不执行任何操作
          break;
        case 'export':
          this.exportReport();
          break;
      }
    },

    generateReport() {
      // 更改状态为生成中
      this.reportStatus = 'generating';
      report.downloadWord(this.option.number).then(()=>{
        this.startPollingReportStatus();
      });
    },

    startPollingReportStatus() {
      // 清除可能存在的旧轮询
      if (this.reportGenerateInterval) {
        clearInterval(this.reportGenerateInterval);
      }

      // 启动新轮询
      this.reportGenerateInterval = setInterval(() => {
        report.downloadWord(this.option.number).then((res)=>{
          console.log(res)
          if (res.data.isGenerating === false) {
            // 生成完成，保存文件地址并更新状态
            this.reportFileUrl = res.data.fileUrl;
            this.reportStatus = 'export';
            // 停止轮询
            if (this.reportGenerateInterval) {
              clearInterval(this.reportGenerateInterval);
              this.reportGenerateInterval = null;
            }
          }
          // 其他情况继续轮询
        }).catch((error) => {
          console.error('获取报告状态失败:', error);
          // 可以选择是否停止轮询或者继续尝试
        });
      }, 3000); // 每3秒查询一次状态
    },

    exportReport() {
      if (this.reportFileUrl) {
        // 直接下载已生成的文件
        const aLink = document.createElement("a");
        aLink.href = this.reportFileUrl;
        aLink.download = this.option.userName + this.option.datePeriod + ".docx";
        aLink.click();
        document.body.appendChild(aLink);
      } else {
        this.$message.error('报告文件地址无效');
      }
    },

    downloadFile() {
      // 保留原有方法以防其他地方调用，但实际已被handleReportAction替代
      const messageInstance = this.$message({
        message: '系统正在生成报告中，请您耐心等待......',
        type: 'info',
        duration: 0
      });
      report.downloadWord(this.option.number).then((res)=>{
        const aLink = document.createElement("a");
        let blob = new Blob([res.data])
        aLink.href = URL.createObjectURL(blob)
        aLink.download = this.option.userName + this.option.datePeriod +".docx"
        aLink.click()
        document.body.appendChild(aLink)
        // 下载完成后关闭消息
        messageInstance.close();
      })
    },

  },
  created() {
    // ponytail: 两种入口 —— 系统内列表带整行 row JSON（防刷新丢参）；独立页/免登入口只带 reportId（报告编号）
    const row = this.$route.query.row;
    if (row) {
      try {
        this.option = JSON.parse(row);
      } catch (e) {
        console.warn('报告行数据解析失败，改用 reportId', e);
      }
    }
  },
  async mounted() {
    window.scrollTo(0, 0);
    const reportNumber = this.option.number || this.$route.query.reportId;
    if (!reportNumber) {
      this.$message.error('缺少报告编号，无法打开报告');
      return;
    }
    this.option.number = reportNumber;
    if (!this.option.datePeriod) {
      await this.loadReportInfo(reportNumber);
    }
    this.periodStartTime = (this.option.datePeriod || '').split(' - ')[0]
    this.periodEndTime = (this.option.datePeriod || '').split(' - ')[1]
    this.queryReportSummaryData() // 获取隐患监测点统计数据
    this.getmonitor_site()  // 获取隐患监测点隐患和设备列表
    this.getHidden_card()
  },
  // ponytail: 报告详情为独立页（不再走控制台 keep-alive），离开页面用 beforeDestroy 清理轮询
  beforeDestroy() {
    if (this.reportGenerateInterval) {
      clearInterval(this.reportGenerateInterval);
      this.reportGenerateInterval = null;
    }
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.risk-device-container {
  margin: 20px 0;
  padding-left: 20px;
}
.device-name {
  padding: 10px;
  margin: 10px 0;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  //background-color: #e6f7ff;
  border-radius: 4px;
}
.device-des {
  padding: 10px;
  margin: 10px 0;
  font-size: 16px;
  color: #333;
  border-radius: 4px;
}
.device-message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  font-size: 14px;
  color: #333;
}
.device-number {
  margin-right: 8px;
  font-weight: bold;
}

.chart-container {
  width: 100%;
  height: 300px;
  margin: 10px 0;
}
.reportDetailPage {
  margin: 0 16px 36px 16px;
  background-color: #fff;

  .cirLine {
    border-top: 1px dashed #ccc;
  }

  .repTop {
    position: relative;
    background-image: url("img/repBg.webp");
    background-size: 100% 100%;
    height: 268px;
    padding-top: 60px;

    .repBtn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      min-width: 130px;
      height: 38px;
      padding: 0 22px;
      background: linear-gradient(135deg, #2A62FF 0%, #5A8AFF 100%);
      border: none;
      border-radius: 8px;
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
      position: absolute;
      top: 64px;
      right: 80px;
      cursor: pointer;
      box-shadow: 0 4px 14px rgba(42, 98, 255, 0.35);
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      user-select: none;
    }
    .repBtn:hover {
      background: linear-gradient(135deg, #5584FF 0%, #7AA4FF 100%);
      box-shadow: 0 6px 20px rgba(42, 98, 255, 0.45);
      transform: translateY(-1px);
    }
    .repBtn:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(42, 98, 255, 0.3);
    }
    .repBtn.generating {
      background: rgba(42, 98, 255, 0.5);
      cursor: not-allowed;
      pointer-events: none;
      box-shadow: none;
      animation: rep-btn-pulse 1.6s ease-in-out infinite;
    }
    .rep-btn-spinner {
      display: inline-block;
      width: 14px;
      height: 14px;
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-top-color: #fff;
      border-radius: 50%;
      animation: rep-spin 0.7s linear infinite;
    }

    .topCon {
      position: relative;
      margin: 0 160px;

      .imgCon {
        display: inline-block;
        vertical-align: top;
        width: 189px;
        height: 152px;
        border: none;
        background-image: url("img/repMap.webp");
        background-size: 100% 100%;
      }

      .detailCon {
        display: inline-block;
        vertical-align: top;
        margin-left: 40px;

        .titleBlack {
          font-size: 24px;
          font-weight: bold;
        }

        .grayCon {
          margin-top: 20px;

          span {
            display: inline-block;
            height: 26px;
            width: 278px;
            background: rgba(0, 0, 0, 0.06);
            border-radius: 2px 2px 2px 2px;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.50);
            line-height: 26px;
            padding-left: 14px;
          }

          span:last-child {
            width: 324px;
            margin-left: 16px;
          }
        }
      }

      .detBom {
        margin-top: 18px;

        .detItem {
          display: inline-block;
          vertical-align: top;
          width: 500px;
          margin-bottom: 8px;

          span:first-child {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.5);
            margin-right: 5px;
          }

          span:last-child {
            color: rgba(0, 0, 0, 0.9);
            font-size: 16px;
          }
        }
      }

    }

  }

  .meunCon {
    height: 622px;
    background-image: url("img/meunBg.webp");
    background-size: 100% 100%;
    padding-top: 30px;

    .meunTitle {
      font-size: 24px;
      font-weight: bold;
      text-align: center;

    }

    .meunEng {
      font-size: 24px;

      text-align: center;
    }

    .blueLine {
      width: 272px;
      height: 0px;
      border-top: 3px solid #4B8DF3;

      margin: 10px auto;
      margin-bottom: 46px;
    }

    .meunItem {
      margin-left: 100px;
      margin-bottom: 80px;
      position: relative;

      .meunNum {
        display: inline-block;
        vertical-align: top;
        width: 28px;
        height: 90px;
        font-size: 82px;
        font-weight: bold;
        font-family: "Alternate", sans-serif;
      }

      .meunDel {
        display: inline-block;
        vertical-align: top;
        margin-left: 36px;
        padding-top: 16px;

        div:first-child {
          font-size: 22px;
          color: #000000;
        }

        div:last-child {
          color: rgba(121, 121, 121, 1);
          margin-top: 15px;
          font-size: 16px;
        }
      }

      .numRig {
        position: absolute;
        top: 24px;
        right: 96px;
        color: rgba(75, 141, 243, 1);
        font-size: 28px;
        font-weight: bold;
      }
    }
  }

  .fuTitle {
    font-size: 22px;
    color: #000000;
    line-height: 26px;
  }

  .text{
    border: 1px solid black;
    flex: 1;
  }

  .grayTitle {
    color: rgba(0, 0, 0, 0.50);
    font-size: 18px;
    margin-top: 24px;
  }

  .risk-type-count {
    color: rgba(75, 141, 243, 1);
  }

  .cavGroup {
    height: 10vw;
    min-height: 100px;
    display: flex;
    justify-content: space-around;

    .count-box {
      width: 40%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;

      .cavItem {
        width: 158px;
        height: 150px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .risk-level-box {
    width: 100%;
    padding: 1vw 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .blackFont {
    color: rgba(0, 0, 0, 0.90);
    font-size: 36px;
    text-align: center;
    z-index: 100;
    font-weight: bold;
  }

  .grayFont {
    color: rgba(0, 0, 0, 0.50);
    font-size: 16px;
    margin-top: 10px;
  }

  .orgFont {
    color: rgba(217, 97, 0, 1);
    font-size: 36px;

    font-weight: bold;
    text-align: center;
    z-index: 100;
  }

  .thibg {
    border: 1px solid #EBEEF5;
    //background-color:rgb(250,244,244) ;
    background-size: 100% 100%;
  }

  .redFont {
    color: rgba(217, 0, 0, 1);
    font-size: 36px;
    z-index: 100;
    font-weight: bold;
    text-align: center;
  }

  .leftCav {
    width: 295px;
    height: 150px;
  }

  .secfFu {
    margin-top: 64px;

    img {
      position: relative;
      left: 5px;
      top: 2px;
    }
  }

  .listItem {
    width: 100%;
    display: flex;
    align-items: center;
    flex: 1 0 auto;

    .line-chart-item {
      height: 3em;
      display: flex;
      align-items: center;
      flex: 0 0 auto;

      .level-name {
        width: 5em;
        text-align: right;
        font-size: 18px;
        color: rgba(0, 0, 0, 0.9);
        line-height: 21px;
      }

      .base-line {
        width: 20vw;
        height: 1vw;
        background-color: rgba(230, 233, 236, 1);
        border-radius: 1vw;
        margin: 0 1vw;
        display: flex;
        flex: 0 0 auto;
      }

      .active-line {
        min-width: 0;
        height: 1vw;
        background-image: linear-gradient(to right, rgba(142, 202, 254, 1), rgb(174, 174, 174));
        border-radius: 1vw;
      }

      .false-alarm-line {
        height: 1vw;
        border-radius: 0 1vw 1vw 0;
        border-left: 2px solid #fff;
      }

      .risk-type-count {
        flex: 0 0 auto;
        display: inline-block;
        min-width: 4em;
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
      }
    }

    p {
      margin: 0 0 0 2em;
    }

    .misreport-count {
      color: #acacac;
      font-weight: bold;
      font-size: 16px;
    }

    .misreport-label {
      color: #999;
      font-size: 14px;
    }
  }

  .misreport-item {
    border-top: 1px dashed #e0e0e0;
    padding-top: 10px;
    margin-top: 8px;
  }

  .typeRight {
    display: inline-block;
    vertical-align: top;
    width: 580px;
    padding-top: 0px;
    color: rgba(0, 0, 0, 0.70);
    font-size: 18px;
    margin-left: 58px;

    p {
      margin-bottom: 14px;
    }
  }

  .detailTem {
    margin-top: 20px;
    color: rgba(0, 0, 0, 1);

    line-height: 21px;
    font-size: 18px;


    p {
      margin-bottom: 10px;
    }
  }

  .adviceItem {
    width: 1310px;
    height: 170px;
    margin: 0px auto;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #8CC8FD;
    color: rgba(0, 0, 0, 0.50);
    font-size: 18px;
    margin-bottom: 56px;

    .adviceTop {
      padding: 11px 0 0 15px;
      color: rgba(0, 0, 0, 1);
      line-height: 21px;
      font-size: 14px;
      margin-bottom: 10px;
    }

    .adDeta {
      padding-left: 54px;
      margin-bottom: 6px;
      color: rgba(0, 0, 0, 1);
      line-height: 21px;
      font-size: 14px;
      font-family: Arial, "Microsoft Yahei", sans-serif;
    }

  }

  .thiCon {
    margin-bottom: 98px;

    .tableItem {
      width: 1200px;
      margin-top: 30px;
      border: 1px solid #EBEEF5;
      border-bottom: none;

      .thP {

        font-size: 18px;
        padding-left: 50px;
        line-height: 60px;
        height: 60px;
        color: #0052D9;
        border-bottom: 1px solid #EBEEF5;
      }
    }

  }

  .table {
    margin-top: 28px;
    margin-right: 80px;
    border-left: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
  }
}

.hidden-card {
  flex: 1;
  margin: 20px 0;
}

.bigtableList {
  overflow: hidden;
}

.tableName {
  text-align: center;
  height: 38px;
  line-height: 38px;
}
.thiCon {
  // ... 其他样式保持不变 ...

  .bigtableList {
    margin: 20px 0;

    /deep/ .el-table {
      // 设置表格内容垂直对齐
      .cell {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      // 设置多行内容的间距
      .cell > div {
        margin: 4px 0;
      }
    }
  }

}
/* ponytail: 按钮动画 — 仅报告页内使用 */
@keyframes rep-btn-pulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}
@keyframes rep-spin {
  to { transform: rotate(360deg); }
}

.page {
  margin: 20px 0;
  display: flex;
  justify-content: flex-end;

  /deep/ .el-pagination {
    .el-pager li {
      &.active {
        background-color: #4B8DF3;
        color: #fff !important;
        &:hover {
          color: #fff !important;
        }
      }
      &.number.active {
        color: #fff !important;
      }
    }
  }
}
.device-info {
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;

  .message-text {
    margin-bottom: 15px;
    color: #666;
    line-height: 1.5;
  }

  .chart-container {
    width: 100%;
    height: 400px;
    margin-top: 15px;
  }
}
.dialog-content {
  padding: 20px;

  h3 {
    margin-bottom: 20px;
    font-size: 18px;
    color: #333;
    font-weight: bold;
  }
}
</style>
<style>
#app .reportDetailPage .el-table th {
  background-color: #fff;
}

/* 表格全局设置强制边框 */
#app .reportDetailPage .el-table--border {
  border: 1px solid #EBEEF5 !important;
}

#app .reportDetailPage .el-table--border::after,
#app .reportDetailPage .el-table--border::before {
  background-color: #EBEEF5 !important;
}

/* 强制所有单元格显示边框 */
#app .reportDetailPage .el-table--border td,
#app .reportDetailPage .el-table--border th {
  border-right: 1px solid #EBEEF5 !important;
  border-bottom: 1px solid #EBEEF5 !important;
}

/* 强制保留被合并单元格的边框 */
#app .reportDetailPage .el-table__body tr.el-table__row td {
  border-right: 1px solid #EBEEF5 !important;
  border-bottom: 1px solid #EBEEF5 !important;
}

/* 强制显示表头边框 */
#app .reportDetailPage .el-table__header-wrapper th {
  border-bottom: 1px solid #EBEEF5 !important;
  border-right: 1px solid #EBEEF5 !important;
}

/* 强制显示边框即使对合并单元格 */
#app .reportDetailPage .el-table__body-wrapper .el-table__row {
  border-top: 1px solid #EBEEF5 !important;
}

#app .reportDetailPage .el-table__body-wrapper .el-table__row td {
  border-left: 1px solid #EBEEF5 !important;
  box-shadow: 1px 0 0 0 #EBEEF5, 0 1px 0 0 #EBEEF5;
}

/* 特别处理隐患定位和隐患设备两列 */
#app .reportDetailPage .el-table__body tr td:nth-child(5),
#app .reportDetailPage .el-table__body tr td:nth-child(6) {
  border-left: 1px solid #EBEEF5 !important;
  border-right: 1px solid #EBEEF5 !important;
  border-top: 1px solid #EBEEF5 !important;
  border-bottom: 1px solid #EBEEF5 !important;
  box-shadow: -1px 0 0 0 #EBEEF5, 1px 0 0 0 #EBEEF5, 0 1px 0 0 #EBEEF5, 0 -1px 0 0 #EBEEF5;
}
#app .reportDetailPage .el-table__body tr td:nth-child(6) .cell {
  text-align: left !important;
  justify-content: flex-start !important;
}
</style>
